module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-141.17a5ae83.svg";